import axios from 'axios'
import config from '@/config/config'
import store from '@/store/store'

export default class BaseRequest {
  constructor() {
    this.baseUrl = config.apiBaseUrl

    const lang = store.getters['settings/getLanguage']
    axios.defaults.headers.common['Language-Id'] = lang

    if (store.getters['oauth/isLogin']) {
      const token = store.getters['oauth/getToken']
      axios.defaults.headers.common['adminAuthToken'] = token.accessToken

      if (config.alibabaCloudAppcode !== '') {
        axios.defaults.headers.common['Authorization'] =
          'APPCODE ' + config.alibabaCloudAppcode
      }
    }
  }
}
